/* Baby Basket — colour picker, pick-your-own packs, stock limits and order notes. Loaded after theme.js. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const BB = window.BB || { routes: {} };
  const root = (BB.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Stock ----------
     data-stock > 0  : in stock, a customer can buy at most that many (counting what is already in the basket).
     data-stock <= 0 : sold out, cannot be added. */
  const PRE_MAX = 20;
  const inCart = {};
  const loadCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((c) => {
      Object.keys(inCart).forEach((k) => delete inCart[k]);
      c.items.forEach((i) => { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      document.dispatchEvent(new Event('bb:stock'));
    })
    .catch(() => {});
  const isPre = (stock) => Number(stock) <= 0;
  const left = (id, stock) => Math.max(0, Number(stock) - (inCart[id] || 0));

  const form = $('#ProductForm');
  const addBtn = $('[data-add-btn]');
  const idInput = $('[data-variant-id]');
  const qtyInput = $('[data-qty] input');
  const preNote = $('[data-bb-preorder]');
  const preProp = $('[data-bb-preorder-prop]');
  const packRadio = $('[data-bb-mode] input[value="pack"]');
  const packMode = () => !!(packRadio && packRadio.checked);

  /* Button, quantity cap and sold-out note for the single item currently selected. */
  const syncSingle = () => {
    if (!addBtn || !idInput || packMode()) return;
    const stock = idInput.dataset.stock;
    const pre = isPre(stock);
    const n = left(idInput.value, stock);
    if (preNote) preNote.hidden = !pre;
    if (preProp) preProp.disabled = !pre;
    addBtn.disabled = n <= 0;
    addBtn.textContent = n <= 0 ? addBtn.dataset.soldText : (pre ? addBtn.dataset.preText : addBtn.dataset.addText);
    if (qtyInput) { qtyInput.max = Math.max(1, Math.min(PRE_MAX, n)); if (Number(qtyInput.value) > n) qtyInput.value = Math.max(1, n); }
  };

  /* ---------- Variant pills ---------- */
  const json = $('[data-bb-variants]');
  if (json) {
    const variants = JSON.parse(json.textContent);
    const groups = $$('[data-bb-option]');
    const mark = () => {
      if (groups.length !== 1) return;
      $$('.swatch', groups[0]).forEach((lab) => {
        const v = variants.find((x) => x.options[0] === $('input', lab).value);
        lab.classList.toggle('is-preorder', !!v && isPre(v.stock));
      });
    };
    const update = () => {
      const opts = groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
      groups.forEach((g, i) => { const l = $('[data-bb-option-label]', g); if (l) l.textContent = opts[i] || ''; });
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      idInput.value = v.id;
      idInput.dataset.stock = v.stock;
      mark();
      syncSingle();
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      if (v.media > 0) { const t = $(`[data-thumb="${v.media - 1}"]`); if (t) t.click(); }
    };
    groups.forEach((g) => g.addEventListener('change', update));
    mark();
  }
  document.addEventListener('bb:stock', syncSingle);
  syncSingle();

  /* ---------- Pick-your-own pack: each piece is its own single, so stock is counted per colour ---------- */
  const pack = $('[data-bb-pack]');
  const modeBox = $('[data-bb-mode]');
  if (pack && modeBox) {
    const size = Number(pack.dataset.size) || 0;
    const rows = $$('[data-bb-pack-row]', pack);
    const countEl = $('[data-bb-pack-count]', pack);
    const priceBox = $('[data-bb-price]');
    const singlePriceHTML = priceBox ? priceBox.innerHTML : '';
    const optionBoxes = $$('[data-bb-option]');
    const singleOnly = $$('[data-bb-single-only]');
    const qtyOf = (r) => Number($('[data-bb-pack-qty]', r).textContent) || 0;
    const maxOf = (r) => left(r.dataset.id, r.dataset.stock);
    const total = () => rows.reduce((n, r) => n + qtyOf(r), 0);
    const refresh = () => {
      const on = packMode();
      const n = total();
      pack.hidden = !on;
      optionBoxes.forEach((b) => { b.hidden = on; });
      singleOnly.forEach((b) => { b.hidden = on; });
      if (countEl) countEl.textContent = n;
      let anyPre = false;
      rows.forEach((r) => {
        if (qtyOf(r) > maxOf(r)) $('[data-bb-pack-qty]', r).textContent = maxOf(r);
        $('[data-bb-pack-plus]', r).disabled = n >= size || qtyOf(r) >= maxOf(r);
        $('[data-bb-pack-minus]', r).disabled = qtyOf(r) === 0;
        r.classList.toggle('is-picked', qtyOf(r) > 0);
        if (qtyOf(r) > 0 && isPre(r.dataset.stock)) anyPre = true;
      });
      if (priceBox && pack.dataset.price) priceBox.innerHTML = on ? `<span class="price">${pack.dataset.price}</span>` : singlePriceHTML;
      if (on) {
        if (preNote) preNote.hidden = !anyPre;
        if (preProp) preProp.disabled = true;
        if (addBtn) { addBtn.disabled = n !== size; addBtn.textContent = n === size ? (anyPre ? addBtn.dataset.preText : addBtn.dataset.addText) : `${addBtn.dataset.addText} (${n}/${size})`; }
      } else {
        syncSingle();
      }
    };
    rows.forEach((r) => { if (r.dataset.preset) $('[data-bb-pack-qty]', r).textContent = '1'; });
    pack.addEventListener('click', (e) => {
      const b = e.target.closest('[data-bb-pack-plus],[data-bb-pack-minus]');
      if (!b) return;
      const r = b.closest('[data-bb-pack-row]');
      const plus = b.matches('[data-bb-pack-plus]');
      const q = qtyOf(r) + (plus ? 1 : -1);
      if (q < 0 || (plus && (total() >= size || q > maxOf(r)))) return;
      $('[data-bb-pack-qty]', r).textContent = q;
      const m = Number(r.dataset.media); if (m > 0 && q > 0) { const t = $(`[data-thumb="${m - 1}"]`); if (t) t.click(); }
      refresh();
    });
    modeBox.addEventListener('change', () => { if (packMode()) { const t = $('[data-thumb="0"]'); if (t) t.click(); } refresh(); });
    document.addEventListener('bb:stock', refresh);

    /* Runs before the theme's add-to-cart handler: swap the single id for one line per chosen colour. */
    document.addEventListener('submit', (e) => {
      const f = e.target;
      if (!packMode() || !f.contains(pack)) return;
      if (total() !== size) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      const picked = rows.filter((r) => qtyOf(r) > 0);
      const summary = picked.map((r) => `${r.dataset.name} ×${qtyOf(r)}`).join(', ');
      const tag = `${pack.dataset.label} #${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
      const shared = $$('[name^="properties["]', f).filter((el) => !el.disabled && el.value.trim() && !el.matches('[data-bb-preorder-prop]'));
      const off = $$('[name="id"],[name="quantity"],[name^="properties["]', f).filter((el) => !el.disabled);
      const added = [];
      const add = (name, value) => { const i = document.createElement('input'); i.type = 'hidden'; i.name = name; i.value = value; f.appendChild(i); added.push(i); };
      picked.forEach((r, i) => {
        add(`items[${i}][id]`, r.dataset.id);
        add(`items[${i}][quantity]`, qtyOf(r));
        add(`items[${i}][properties][Pack · العبوة]`, `${tag}: ${summary}`);
        if (isPre(r.dataset.stock) && preProp) add(`items[${i}]${preProp.name.slice(preProp.name.indexOf('['))}`, preProp.value);
        shared.forEach((el) => add(`items[${i}]${el.name.slice(el.name.indexOf('['))}`, el.value));
      });
      off.forEach((el) => { el.disabled = true; });
      setTimeout(() => { off.forEach((el) => { el.disabled = false; }); added.forEach((el) => el.remove()); refresh(); }, 0);
    }, true);
    refresh();
  }

  /* ---------- Never add more than what is in stock (product page and quick-add cards) ---------- */
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches('form[data-ajax-cart]')) return;
    const id = $('[name="id"]:not(:disabled)', f);
    const q = $('[name="quantity"]:not(:disabled)', f);
    if (id && id.dataset.stock !== undefined) {
      const n = left(id.value, id.dataset.stock);
      if (Number(q ? q.value : 1) > n) { e.preventDefault(); e.stopImmediatePropagation(); if (f === form) syncSingle(); return; }
    }
    setTimeout(loadCart, 1500);
  }, true);
  document.addEventListener('click', (e) => { if (e.target.closest('[data-line-qty]')) setTimeout(loadCart, 1500); });
  document.addEventListener('change', (e) => { if (e.target.closest('[data-line-input]')) setTimeout(loadCart, 1500); });
  loadCart();

  /* ---------- Leave out empty optional fields (e.g. a blank note) ---------- */
  document.addEventListener('submit', (e) => {
    const fields = $$('[data-bb-optional]', e.target).filter((el) => !el.value.trim());
    fields.forEach((el) => { el.disabled = true; });
    setTimeout(() => fields.forEach((el) => { el.disabled = false; }), 0);
  }, true);

  /* ---------- Save the cart note as it is typed ---------- */
  let noteTimer;
  const saveNote = (note) => fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ note })
  }).catch(() => {});
  document.addEventListener('input', (e) => {
    const t = e.target.closest('[data-bb-cart-note]');
    if (!t) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => saveNote(t.value), 500);
  });

  /* ---------- Gift option (one per order) ---------- */
  const SECTION_DRAWER = 'cart-drawer';
  const refreshCart = () => {
    if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
    return fetch(`${window.location.pathname}?sections=${SECTION_DRAWER}`).then((r) => r.json()).then((d) => {
      const doc = new DOMParser().parseFromString(d[SECTION_DRAWER], 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
      const current = document.querySelector('[data-cart-drawer] .drawer__panel');
      if (fresh && current) current.replaceWith(fresh);
      const n = (doc.querySelector('[data-cart-count-source]') || {}).textContent;
      if (n) document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n.trim() === '0' ? '' : n.trim(); el.dataset.count = n.trim(); });
    });
  };
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-bb-gift-toggle]');
    if (!t) return;
    const box = t.closest('[data-bb-gift]');
    box.style.opacity = '.6'; t.disabled = true;
    const req = t.checked
      ? fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(box.dataset.variant), quantity: 1 }] }) })
      : fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: { [box.dataset.key]: 0 }, attributes: { 'Gift message': '' } }) });
    req.then(refreshCart).catch(() => { box.style.opacity = ''; t.disabled = false; });
  });
  let giftTimer;
  document.addEventListener('input', (e) => {
    const t = e.target.closest('[data-bb-gift-msg]');
    if (!t) return;
    clearTimeout(giftTimer);
    giftTimer = setTimeout(() => fetch(`${root}cart/update.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift message': t.value } })
    }).catch(() => {}), 500);
  });
})();
